import {
  PaymentPrefAddressFullFragment,
  SubscriptionAddressFullFragment,
} from "#graphql/supergraphTypes";
import { Address } from "../../common/types";

export const getAddress = (
  address?: SubscriptionAddressFullFragment | PaymentPrefAddressFullFragment,
): Address | undefined => {
  if (!address) {
    return undefined;
  }
  return {
    street: address.street,
    street2: address.street2,
    street3: address.street3,
    city: address.city,
    state: address.state?.name,
    region: address.region,
    country: address.country?.name,
    postalCode: address.postalCode,
    countryId: address.country?.id,
    stateId: address.state?.id,
  };
};
